import styled from 'styled-components'

/**
 * Styled components for LaneEditor
 */

export const LaneEditorWrapper = styled.span`
  &.lane-editor {
    /* Preserve original className for styling compatibility */
  }
`

export const TriggerWrapper = styled.span`
  cursor: pointer;
`
